export default __webpack_public_path__ + "static/media/medicine.e099377a.svg";